import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Trans, useTranslation } from 'react-i18next';

import styles from '@/common/containers/ModuleOverview/styles.less';

const Immediate = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.blockBody}>
      <h4 className={styles.contentTitle}>
        {t('Immediate tasks module overview')}
      </h4>
      <div className={styles.contentDescription}>
        {t('Immediate tasks will:')}
        <ul>
          <ol>
            {t(
              '1. Notify family, friends, and (if applicable) current employers of the death.'
            )}
          </ol>
          <ol>
            {t(
              '2. Stop payments in order to avoid overpayments that must be repaid at a later date.'
            )}
          </ol>
          <ol>
            {t('3. Prevent the potential of identity or asset theft.')}
          </ol>
          <ol>
            {t('4. Address other urgent issues.')}
          </ol>
        </ul>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Instructions')}</h3>
      <div className={styles.contentStepper}>
        <Stepper orientation="vertical">
          <Step active>
            <StepLabel className={styles.contentStep}>
              {t('Complete the “Immediate task Questionnaire”')}
            </StepLabel>
          </Step>
          <Step active>
            <StepLabel className={styles.contentStep}>
              {t('Complete all task on the “Immediate tasks List”')}
            </StepLabel>
          </Step>
        </Stepper>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Timeframe')}</h3>
      <div className={styles.contentTimeFrame}>
        <ul>
          <ol>
            <Trans
              i18nKey="Complete these tasks as <1>soon as possible</1> (ideally, within 7 days of the date of the death)"
              components={{ 1: <b /> }}
            />
          </ol>
        </ul>
      </div>
    </div>
  );
};

export default Immediate;
